module.exports = __webpack_public_path__ + "img/chehulu3.9f389787.jpg";